<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-overlay
      :absolute="true"
      :dark="false"
      z-index="9999"
    >
      <v-card width="450" class="rounded-lg">
        <v-card-title>
          Remove Layer
        </v-card-title>
        <v-card-text>
          This action will remove the layer and all the points in it.<br/>
          Do you really want to delete a <b>{{ item.map_name }} / {{ item.name }}</b> layer?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" dark text @click="cancel">Cancel</v-btn>
          <v-btn color="red darken-1" dark @click="remove">Remove</v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
  </v-row>
</template>

<script>
import L from 'leaflet'
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      categories: []
    }
  },
  mounted () {
    L.DomEvent.disableClickPropagation(this.$el)
    L.DomEvent.disableScrollPropagation(this.$el)
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    async remove () {
      const { data } = await this.$axios.delete(
        this.$store.getters.projectPath + '/runtime-layers/' + this.item.map_name + '/' + this.item.id
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.$toasted.success('Layer removed')
        this.$emit('remove', this.item)
        this.$emit('close')
      }
    }
  }
}
</script>
